import { createAction, props } from "@ngrx/store";

export const setTitle = createAction("[Title] Set title", props<{ data: string; data2?: string; data3?: string }>());
export const resetTitle = createAction("[Core] Reset");
